import { Table } from '@tanstack/react-table';
import { Search } from 'lucide-react';
import { cn } from '../../utils/cn';
import { Input } from '../input/input';

type DataTableGlobalSearchProps<TData> = {
  table: Table<TData>;
  placeholder?: string;
  className?: string;
};

export const DataTableGlobalSearch = <TData,>({
  table,
  placeholder = 'Search',
  className,
}: DataTableGlobalSearchProps<TData>) => {
  return (
    <Input
      placeholder={placeholder}
      value={table.getState().globalFilter ?? ''}
      onChange={(e) => {
        table.setGlobalFilter(e.target.value);
      }}
      leftIcon={<Search />}
      clearable
      onClear={() => table.setGlobalFilter('')}
      className={cn('h-9 w-48 border-transparent bg-accent text-muted-foreground', className)}
    />
  );
};
